module.exports = __webpack_public_path__ + "img/img1.e93f4b9c.png";